module.exports = {
        srcSet: "/_next/static/images/forbes@3x-87-6bbcba789d62f4cc.png"+" 87w"+","+"/_next/static/images/forbes@3x-174-383afcd87d698fd7.png"+" 174w"+","+"/_next/static/images/forbes@3x-261-ec3aa8747d2c4ea8.png"+" 261w",
        images: [{path: "/_next/static/images/forbes@3x-87-6bbcba789d62f4cc.png",width: 87,height: 22},{path: "/_next/static/images/forbes@3x-174-383afcd87d698fd7.png",width: 174,height: 44},{path: "/_next/static/images/forbes@3x-261-ec3aa8747d2c4ea8.png",width: 261,height: 65}],
        src: "/_next/static/images/forbes@3x-261-ec3aa8747d2c4ea8.png",
        toString: function(){return "/_next/static/images/forbes@3x-261-ec3aa8747d2c4ea8.png"},
        
        width: 261,
        height: 65
      }